import React, { memo, useEffect } from "react";
import { Match, User } from "../../types";
import { Card, CircularProgress, Stack, styled, Typography } from '@material-ui/core';

import { actions } from '../../services/userMatches';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { Box } from "@material-ui/system";
import { ProfileAvatar } from "../../components/UserPhoto/UserPhoto";
import timeAgo from "../../utils/timeAgo";
import { areEqual, FixedSizeList, ListChildComponentProps } from "react-window";
import { ReactWindowScroller } from "../../components/WindowScroller";

const MatchItem: React.FC<ListChildComponentProps<Match[]>> = ({ data, index, style }) => {

  const match = data[ index ];

  return (
    <Box style={style} sx={{ pb: 1 }}>
      <Stack direction="row" justifyContent="center">
        <Card variant="outlined" sx={{ padding: 1, minWidth: 350, }}>
          <Stack direction="column" spacing={0.2} alignItems="center">
            <Stack direction="row" spacing={1}>
              <ProfileAvatar userId={match.users[ 0 ]} size={100} />
              <ProfileAvatar userId={match.users[ 1 ]} size={100} />
            </Stack>
            <Typography variant="caption">
              Status: {match.status}
            </Typography>
            <Typography variant="caption">
              Created: {timeAgo(match.createTime.toDate())}
            </Typography>
          </Stack>
        </Card>
      </Stack>
    </Box>
  );
};

const MatchItemMemo = memo(MatchItem, areEqual);


const Root = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  flex: 1,
});

interface Props {
  user: User;
}

const UserMatches: React.FC<Props> = ({ user }) => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.userMatches);

  useEffect(() => {

    dispatch(actions.loadMatches(user.id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ user.id ]);

  if (state.loading || !state.matches[ user.id ]) {
    return (
      <Root>
        <CircularProgress />
      </Root>
    );
  }

  return (
    <Root>
      <ReactWindowScroller>
        {({ ref, outerRef, style, onScroll }) => (
          <FixedSizeList
            ref={ref}
            outerRef={outerRef}
            style={style}
            onScroll={onScroll}
            height={window.innerHeight}
            width="100%"
            itemCount={state.matches[ user.id ].length}
            itemSize={170}
            itemData={state.matches[ user.id ]}
          >
            {MatchItemMemo}
          </FixedSizeList>
        )}
      </ReactWindowScroller>
    </Root>
  );
};

export default UserMatches;